import { createContext, ReactNode, useContext } from 'react'

interface ChatScrollContextType {
  scrollToBottom: () => void
}

const ChatScrollContext = createContext<ChatScrollContextType | undefined>(undefined)

export const useChatScroll = () => {
  const context = useContext(ChatScrollContext)
  if (!context) {
    throw new Error('useChatScroll must be used within a ChatScrollProvider')
  }
  return context
}

interface ChatScrollProviderProps {
  scrollToBottom: () => void
  children: ReactNode
}

export const ChatScrollProvider = ({ scrollToBottom, children }: ChatScrollProviderProps) => {
  return <ChatScrollContext.Provider value={{ scrollToBottom }}>{children}</ChatScrollContext.Provider>
}
